import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import SearchInput from 'search/inputs/SearchInput';

interface SearchEditorProps {
  config: string | null;
  onChangeConfig: (config: string | null) => void;
  modelTypes: Array<ModelTypeConstants>;
  disabled?: boolean;
}

export default function SearchEditor({
  config,
  onChangeConfig,
  disabled,
  modelTypes,
}: SearchEditorProps): JSX.Element {
  return (
    <SearchInput
      autoFocus={false}
      disabled={disabled}
      disableTyping={config != null}
      isMulti={false}
      onRemove={() => {
        onChangeConfig(null);
      }}
      onSelect={(itemId) => {
        onChangeConfig(itemId);
      }}
      placeholder=""
      selected={config == null ? [] : [config]}
      types={modelTypes}
    />
  );
}
